









































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IProvisionConfiguration } from "@/models/provisioning";

@Component({
  components: {
    "provision-configurations-provider": () =>
      import(
        "@/components/app/admin/provisioning/provisionConfigurationsProvider.vue"
      ),
    "provision-configurations-listing": () =>
      import(
        "@/components/app/admin/provisioning/provisionConfigurationsListing.vue"
      )
  }
})
export default class MergeProviderConfigurationsModal extends Vue {
  // Prop

  @Prop({ required: true })
  public configuration!: IProvisionConfiguration;

  // Data

  public isProcessing = false;
  public selectedConfigurations: IProvisionConfiguration[] = [];
  public manualFilters = {
    "filter[id|neq]": this.configuration.id,
    "filter[provider_id]": this.configuration.provider_id
  };

  // Methods

  public selectConfiguration(newSelectedConfiguration, value) {
    if (!value) {
      this.selectedConfigurations = _.filter(
        this.selectedConfigurations,
        selectedProduct => selectedProduct.id !== newSelectedConfiguration.id
      );
    } else if (
      !_.some(this.selectedConfigurations, ["id", newSelectedConfiguration.id])
    ) {
      this.selectedConfigurations = [];
      this.selectedConfigurations.push(newSelectedConfiguration);
    }
  }

  public async mergeConfigurations() {
    try {
      this.isProcessing = true;

      await this.$store.dispatch(
        `data/${DataModules.PROVISIONING_CONFIGURATIONS}/mergeConfigurations`,
        {
          configurationId: this.selectedConfigurations[0].id,
          oldConfigurationId: this.configuration.id,
          message: this.$t(
            "_sentence.merge_provision_configurations_confirmation",
            {
              oldConfigurationName: this.configuration.name,
              newConfigurationName: this.selectedConfigurations[0].name
            }
          ),
          onSuccess: () => {
            this.$emit("success");
            this.$emit("close");
          }
        }
      );
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  // Computed

  public get buttonIsDisabled() {
    return _.isEmpty(this.selectedConfigurations);
  }
}
